import { Link } from "react-router-dom";
import undrawProfile from "../img/undraw_profile.svg";
import serviceIcon from "../img/service.png";
import {
  concatenateAndTruncate,
  truncateText,
} from "../../utils/application-helper";

const UserListView = ({ user, children, isSibebarDisplay = false }) => {
  const getDynamicKey = () =>
    user?.experties?.length && user.experties[0]?.name ? "name" : "value";
  return (
    <div>
      {!isSibebarDisplay && (
        <div className="mb-4 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-between w-60">
            <Link to={`../${user?.userName}`}>
              <div className="sme-profile">
                <img
                  className={`img-profile rounded-circle mr-3 ${
                    user?.offerService ? "sme-mini-service" : null
                  }`}
                  src={user?.picUrl || undrawProfile}
                />
                {user?.offerService && (
                  <div className="sme-mini-icon" style={{ right: "8px" }}>
                    SME
                  </div>
                )}
              </div>
            </Link>
            <p className="follow-name mb-0 ">
              <Link to={`../${user?.userName}`}>
                {user?.fName || ""} {user?.lName || ""}
                {user?.fName === null && user?.lName === null && user?.userName}
                <br />
                <span className="follow-des">
                  {user?.experiences ? truncateText(user.experiences, 30) : ""}
                </span>
              </Link>
            </p>
          </div>
          <div className="connection-lists">{children}</div>
        </div>
      )}
      {isSibebarDisplay && (
        <div className="mb-4 d-flex">
          <div className="">
            <Link to={`../${user?.userName}`}>
              <div className="sme-profile">
                <img
                  className={`img-profile rounded-circle ${
                    user?.offerService ? "sme-mini-service" : null
                  }`}
                  src={user?.picUrl || undrawProfile}
                />
                {user?.offerService && (
                  <div className="sme-mini-icon" style={{ right: "8px" }}>
                    SME
                  </div>
                )}
              </div>
            </Link>
          </div>
          <div className="pl-2 cursor-pointer">
            <Link to={`../${user.userName}`}>
              <p className="follow-name mb-0">
                {user?.fName || ""} {user?.lName || ""}
              </p>
            </Link>
            <p className="follow-des">
              {user?.experties
                ? concatenateAndTruncate(user.experties, 30, getDynamicKey())
                : ""}
            </p>
            <div className="">{children}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserListView;
